export const CONTINUE_SYMBOL = "[continue]";
